// Static dataset extracted from
// "NTACT COMPANIES HSE PERFORMANCE STATS_App.xlsx".
// Update these values whenever the source spreadsheet changes.

export const EMR_HISTORY = [
  { year: 2014, rate: 0.80 },
  { year: 2015, rate: 0.73 },
  { year: 2016, rate: 0.61 },
  { year: 2017, rate: 0.59 },
  { year: 2018, rate: 0.60 },
  { year: 2019, rate: 0.61 },
  { year: 2020, rate: 0.59 },
  { year: 2021, rate: 0.56 },
  { year: 2022, rate: 0.80 },
  { year: 2023, rate: 0.82 },
  { year: 2024, rate: 0.63 },
  { year: 2025, rate: 0.53 },
  { year: 2026, rate: 0.48 },
];

const COMPANY_YEARS = [
  2025, 2024, 2023, 2022, 2021, 2020, 2019, 2018, 2017, 2016, 2015, 2014, 2013, 2012, 2011, 2010,
];
const PROCESSORS_YEARS = [2025, 2024, 2023, 2022, 2021];

const buildSeries = (years, rows) =>
  years.map((y, i) => {
    const obj = { year: y };
    for (const k in rows) obj[k] = rows[k][i];
    return obj;
  });

export const COMPANY_STATS = {
  CONSTRUCTORS: {
    label: "NTACT Constructors, Ltd.",
    color: "#155DFC",
    series: buildSeries(COMPANY_YEARS, {
      recordable: [0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 1, 0, 0],
      lostTime:   [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      fatalities: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      hours:      [950080, 1042784, 1039087, 495206, 347417, 294549, 929105, 678967, 543031, 186254, 347766.5, 410022, 212066, 186689, 22592, 1330],
      employees:  [366, 401, 399, 190, 133, 113, 357, 261, 209, 72, 133, 159, 85, 52, 12, 3],
      trir:       [0, 0, 0, 0, 0, 0, 0.22, 0, 0, 0, 0, 0, 0, 1.07, 0, 0],
    }),
  },
  IE: {
    label: "NTACT I & E, Ltd.",
    color: "#E17100",
    series: buildSeries(COMPANY_YEARS, {
      recordable: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      lostTime:   [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      fatalities: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      hours:      [340000, 487498, 419215, 274654, 198931, 193253, 278009, 201624, 104906, 79209.5, 83641, 82097, 77502, 21675, 9520, 0],
      employees:  [131, 187, 161, 106, 76, 74, 107, 77, 40, 30, 32, 43, 28, 18, 4, 0],
      trir:       [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    }),
  },
  PROCESSORS: {
    label: "NTACT Processors & Engineering, Ltd.",
    color: "#10B981",
    note: "DID NOT EXIST before 2021",
    series: buildSeries(PROCESSORS_YEARS, {
      recordable: [0, 0, 0, 0, 0],
      lostTime:   [0, 0, 0, 0, 0],
      fatalities: [0, 0, 0, 0, 0],
      hours:      [16022, 19398, 101112, 53847, null],
      employees:  [6, 8, 40, 20, null],
      trir:       [0, 0, 0, 0, 0],
    }),
  },
  OPERATIONS: {
    label: "NTACT Operations, LLC. (combined)",
    color: "#9333EA",
    series: buildSeries(COMPANY_YEARS, {
      recordable: [0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 1, 0, 0],
      lostTime:   [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      fatalities: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      hours:      [1306102, 1530282, 1458302, 870972, 600195, 487802, 1207114, 880591, 647937, 265463.5, 431407.5, 492119, 282568, 208364, 32112, 1330],
      employees:  [503, 588, 560, 336, 229, 187, 464, 338, 249, 102, 165, 189, 113, 70, 16, 3],
      trir:       [0, 0, 0, 0, 0, 0, 0.16, 0, 0, 0, 0, 0, 0, 0.95, 0, 0],
    }),
  },
};

export const COMPANY_KEYS = ["CONSTRUCTORS", "IE", "PROCESSORS", "OPERATIONS"];

// Build a year-aligned dataset across all 4 entities for a given metric.
export const buildMetricByYear = (metricKey) => {
  const years = new Set();
  COMPANY_KEYS.forEach((k) =>
    COMPANY_STATS[k].series.forEach((row) => years.add(row.year)),
  );
  const sorted = Array.from(years).sort((a, b) => a - b);
  return sorted.map((y) => {
    const row = { year: y };
    COMPANY_KEYS.forEach((k) => {
      const found = COMPANY_STATS[k].series.find((r) => r.year === y);
      row[k] = found ? found[metricKey] : null;
    });
    return row;
  });
};
